import Countdown from "react-countdown";
import Maximum from "assets/images/svg/maximum_number_exceeded_code.svg";
import { PreregisterDto, usePreregisterData } from "pages/registration/registration.service";
import moment from "moment";
import { client } from "helpers/client";
import { Navigate, useNavigate } from "react-router-dom";

const BlockedMobilePage = () => {
  const navigate = useNavigate();
  const { preregisterData, setPreregisterData } = usePreregisterData();

  if (!preregisterData) return <Navigate to="/temp-register" />;

  async function handleResend() {
    const { response } = await client<PreregisterDto>(`/auth/resendMobileCode/${preregisterData?.mobileId}`, { method: "POST" });

    if (response) {
      setPreregisterData(response);
      return navigate("/temp-validate");
    }
  }

  return (
    <div className="registration link-send">
      <div className="row">
        <div className="col-lg-8 col-md-12 mx-auto">
          <div className="row">
            <div className="col-lg-6 col-md-4">
              <img className="background" src={Maximum} alt="background" />
            </div>
            <div className="col-lg-6 col-md-8">
              <div className="box-linksend">
                <h1>SORRY</h1>
                <p>
                  sorry <br /> It seems you used the maximum number of times to send the verification link code "3 times", please
                  try again after 24 hour
                </p>
                {/* @ts-ignore */}
                <Countdown
                  precision={10000}
                  date={moment(preregisterData.blockTillDate).add(1, "seconds").toDate()}
                  renderer={(p) => (
                    <button disabled={!p.completed} onClick={handleResend} className="btn-blue">
                      {p.completed ? "Send Again" : `${p.formatted.hours}:${p.formatted.minutes}:${p.formatted.seconds}`}
                    </button>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockedMobilePage;
